module.exports = __webpack_public_path__ + "static/fonts/jibunnote.713a9dcb.ttf";